import React, { useEffect, useState } from "react";
import { botApi } from "@/lib/api";
import { Activity } from "lucide-react";

function agoString(iso) {
  if (!iso) return "never";
  const secs = Math.max(0, Math.round((Date.now() - new Date(iso).getTime()) / 1000));
  if (secs < 60) return `${secs}s ago`;
  const mins = Math.floor(secs / 60);
  if (mins < 60) return `${mins}m ago`;
  const hrs = Math.floor(mins / 60);
  if (hrs < 24) return `${hrs}h ago`;
  return `${Math.floor(hrs / 24)}d ago`;
}

export default function BotHealthPill() {
  const [h, setH] = useState(null);

  const load = async () => {
    try { setH(await botApi.health()); } catch (err) { console.debug("[BotHealthPill] poll failed", err); }
  };
  useEffect(() => {
    load();
    const iv = setInterval(load, 15000);
    return () => clearInterval(iv);
  }, []);

  if (!h) return null;
  const last = h.scheduler?.last_tick_at;
  const alive = last && (Date.now() - new Date(last).getTime()) < h.scheduler.interval_seconds * 2500;
  const color = alive ? "text-emerald-300" : "text-amber-300";
  const dot = alive ? "pulse-dot" : "pulse-dot-warn";

  return (
    <div
      data-testid="bot-health-pill"
      className="hidden lg:flex items-center gap-2 px-3 py-1.5 rounded-full border border-white/10 bg-white/5"
      title={`Scheduler ${h.scheduler.enabled ? "ON" : "OFF"} · last tick ${agoString(last)} · processed ${h.scheduler.users_processed_last_tick ?? 0}`}
    >
      <span className={dot} />
      <Activity className="w-3 h-3 text-slate-400" />
      <span className={`font-mono text-[10px] uppercase tracking-[0.25em] ${color}`}>
        Bot {agoString(last)}
      </span>
    </div>
  );
}
